import * as actionTypes from "./actionTypes";
import * as eventTypes from "../../../../../actions/eventTypes";
import initialState from "reducers/initialState";

export const documentDecisionSummaryReducer = (state = initialState.document.decision.summary, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DECISION_SUMMARY_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_DECISION_SUMMARY_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    case eventTypes.OFFER_DECISION_SUMMARY_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loading: false,
          loaded: false
        }
      };
    }

    case eventTypes.OFFER_ORCHESTRATOR_COMPETENCE_ORDER_EXECUTED: {
      return initialState.document.decision.summary;
    }

    default:
      return state;
  }
};

export const contractGenPermissionsReducer = (
  state = initialState.document.decision.contractGenPermissions,
  action
) => {
  switch (action.type) {
    case actionTypes.LOAD_CONTRACT_GEN_PERMISSIONS_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_CONTRACT_GEN_PERMISSIONS_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true
        }
      };
    }

    default:
      return state;
  }
};
